<template>
    <!-- Benefits Section -->
    <section class="py-5 bg-light-creme">
        <div class="container py-5">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <!-- Photo Grid Placeholder -->
                    <div class="row g-3">
                        <div class="col-6">
                            <div class="bg-primary rounded-4" style="height: 200px;"></div>
                        </div>
                        <div class="col-6 pt-5">
                            <div class="bg-secondary rounded-4" style="height: 200px;"></div>
                        </div>
                        <div class="col-6 offset-3 mt-n5">
                            <div class="bg-success rounded-4" style="height: 200px;"></div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 ps-md-5">
                    <h2 class="display-5 fw-bold font-serif mb-4">Benefits You Get When<br> Using Our Service</h2>
                    <p class="text-muted mb-4">High quality materials and comfortable spaces. We create furniture that
                        lasts.</p>
                    <ul class="list-unstyled">
                        <li class="mb-3 d-flex gap-3">
                            <i class="bi bi-check-circle-fill text-brown"></i>
                            <span>Best Quality Materials</span>
                        </li>
                        <li class="mb-3 d-flex gap-3">
                            <i class="bi bi-check-circle-fill text-brown"></i>
                            <span>5 Year Warranty Assurance</span>
                        </li>
                        <li class="mb-3 d-flex gap-3">
                            <i class="bi bi-check-circle-fill text-brown"></i>
                            <span>Free Installation</span>
                        </li>
                    </ul>
                    <a href="#" class="btn btn-outline-dark rounded-pill px-4 mt-3">Learn More <i
                            class="bi bi-arrow-right ms-2"></i></a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "BenefitsSection"
}
</script>
